import { gql } from '@apollo/client';

/**
 * Queries used by more than one feature. The kanban board re-exports these
 * from its own `graphql/queries.ts` so its existing imports keep working.
 */

export const SEARCH_PROJECTS_QUERY = gql`
  query SearchProjects($filter: ProjectFilter, $limit: Int) {
    projects(filter: $filter, limit: $limit) {
      id
      projectNumber
      euAddressShort
      projectManager {
        id
        initials
        name
      }
      distributor {
        id
        name
      }
    }
  }
`;

export const INTERNAL_USERS_QUERY = gql`
  query InternalUsers($filter: InternalUserFilter, $limit: Int) {
    internalUsers(filter: $filter, limit: $limit, orderBy: name_ASC) {
      id
      name
      initials
    }
  }
`;

/**
 * UK bank holidays, straight from gov.uk via the API (england-and-wales,
 * cached server-side). Same source the contracts planner uses.
 */
export const PUBLIC_HOLIDAYS_QUERY = gql`
  query PublicHolidays {
    publicHolidays {
      title
      date
    }
  }
`;

/**
 * The signed-in user's iQD internal user row.
 *
 * Resolved from the request on the API rather than by passing an identifier:
 * the client only knows the Auth0 subject, which changes with the connection
 * (a Microsoft 365 sign-in arrives as `waad|...`), while the API can match on
 * the uuid Auth0 carries in app_metadata.
 */
export const CURRENT_INTERNAL_USER_QUERY = gql`
  query CurrentInternalUser {
    currentInternalUser {
      id
      name
      initials
    }
  }
`;

/**
 * The product's global settings, as key/value rows.
 *
 * The Angular host loads these once into NgRx and reads them out of a Map. The
 * remote has no store, so screens that need one ask for the lot and pick the
 * key out — the query is cached by Apollo, and the API marks the type
 * `@cacheControl(maxAge: 300)`, so a second screen asking costs nothing.
 */
export const SETTINGS_QUERY = gql`
  query Settings {
    settings {
      id
      key
      value
    }
  }
`;
